const API_URL = 'https://photon.komoot.io/api/';

export function makeAddressSearchAdapter({ fetchImpl = fetch } = {}) {
    const cache = new Map();

    return {
        searchAddresses({ query, limit = 5 } = {}) {
            // No need to include the limit as part of the cache key:
            // the limit is always the same in production.
            if (cache.has(query)) {
                return Promise.resolve(cache.get(query));
            }
            const url = new URL(API_URL);
            url.searchParams.set('q',     query);
            url.searchParams.set('limit', limit);
            return fetchImpl(url)
                .then(check_response)
                .then(response => response.json())
                // .then(payload => { console.log(payload); return payload; })
                .then(payload => process(payload.features, query, url))
                .then(result => {
                    cache.set(query, result);
                    return result;
                })
                .catch(error => process([], query, url, error));
        },

        // ==== For testing =========================================

        isCached(query) {
            return cache.has(query);
        },
    };
}

function process(features, query, url, error) {
    if (error) {
        return { addresses : [], query, url, error };
    }
    features ||= [];
    const addresses = [];
    for (const feature of features) {
        if (feature.geometry.type === 'Point') {
            addresses.push(processFeature(feature));
        }
    }
    return { addresses, query, url };
}

// Even though it is not part of the module's public interface, we
// export this function to allow synchronous, and thus simpler tests.
export function processFeature(feature) {
    const [ lon, lat ] = feature.geometry.coordinates;
    return {
        street   : feature.properties.street || feature.properties.name,
        houseno  : feature.properties.housenumber,
        district : feature.properties.district,
        postcode : feature.properties.postcode,
        city     : feature.properties.city,
        country  : feature.properties.country,
        lon,
        lat,
    };
}

function check_response(response) {
    if (!response.ok) {
        throw new Error(`response status ${response.status}`);
    }
    return response;
}
